module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"lead":"小規模から大規模まで:様々なお問い合わせをいただいています:","item1":{"sub":"毎月のご相談数","main":":数100:件"},"item2":{"sub":"1案件の実績パレット量","main":":10〜10,000:まで"},"item3":{"sub":"サービス開始から10ヶ月で","main":"相談数は:約5倍:"},"casestudy":"導入企業例"}}')
  delete Component.options._Ctor
}
